<template>
  <div class="max-content review-page">
    <div class="banner-show">
      <img
        src="https://cdn.sandbox.edstatic.com/202611021511/bb23a4de808af382d91a45ba0af4a991/2026/05/06/83b66085a7b270050c5c202e547072d2b1fb9403.jpg"
        alt="" />
    </div>
    <div class="history-list">
      <div class="item" v-for="(item, index) in historyImages" :key="index" @click="clickItem(item.url)">
        <img :src="item.img" alt="">
      </div>

    </div>
  </div>

</template>
<script>
import {
  MeetingsCarousel,
} from "../../../config/interface.js";

export default {
  data() {
    return {
      historyImages: [
        {
          img: 'https://cdn.sandbox.edstatic.com/202611031347/954ca3efad54c7b88c562bd441083d99/2026/05/07/57ad46f1b47a2c5907494df11a12351941a20f76.png',
          url: 'https://www.vascularnews.cn/vascularNews/meeting/index?meeting_id=596'
        },
        {
          img: 'https://cdn.sandbox.edstatic.com/202611031348/e65dea1491547d74fef7209ff5de485d/2026/05/07/d513e18402c7922bc3aaf91dc553c65669a0b404.png',
          url: 'https://docbook.com.cn/meetingHome/65813'
        },
        {
          img: 'https://cdn.sandbox.edstatic.com/202611031348/d85d8f59260d96f134a2797a0ba79a82/2026/05/07/043ce3412e5bdd7821d9afb537c698f033b7f29c.png',
          url: 'https://docbook.com.cn/meetingHome/62726'
        },
        {
          img: 'https://cdn.sandbox.edstatic.com/202611031349/e1d0f1bb460077c09aca3148ed1f4934/2026/05/07/4dcd4fbe68f7c9cf062ece748502a1f894e23c05.png',
          url: 'https://docbook.com.cn/meetingHome/57681'
        },
        {
          img: 'https://cdn.sandbox.edstatic.com/202611031349/e6283f527066f13cb0f559580f0663de/2026/05/07/4fd2d2125b535da6c9ed5a7b7d1fd3448039504a.png',
          url: 'https://docbook.com.cn/meetingHome/52648'
        },
        {
          img: 'https://cdn.sandbox.edstatic.com/202611031350/f382f894e6dac63f96589242faee5194/2026/05/07/5aaea641b6544e74b4ba707944910c2fdc956bc9.png',
          url: 'https://docbook.com.cn/meetingHome/46745'
        }
      ],
      meeting_id: "674"
    }
  },
  beforeRouteEnter(to, from, next) {
    //  修复iOS版微信HTML5 History兼容性问题
    if (to.path !== location.pathname) {
      location.assign(to.fullPath);
    } else {
      next();
    }
  },
  mounted() {
    this.getMeetingCarousel();
  },
  methods: {

    //会议轮播
    getMeetingCarousel() {
      const url = MeetingsCarousel;
      let params = {
        meeting_id: this.meeting_id
      };
      const method = "POST";
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          this.swiperImg = data;
        }
      });
    },
    clickItem(url) {
      window.location.href = url;
    }
  }
}
</script>
<style scoped lang="scss">
.review-page {
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #e2e2e2;

  .banner-show {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .history-list {
    width: 86%;
    margin-top: 10px;
    margin-left: 7%;

    .item {
      width: 100%;
      margin-bottom: 15px;

      img {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting674/PastReview.vue